import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
interface Testimonial {
  name: string;
  detail: string;
  text: string;
}
const TESTIMONIALS: Testimonial[] = [{
  name: "Roberto, 58",
  detail: "Berazategui, Bs. As.",
  text: "Mi nono era de Calabria y siempre quise el pasaporte. Con esta guía por fin entendí lo de la naturalización. Clarísimo para alguien de mi edad."
}, {
  name: "Susana, 61",
  detail: "Villa María, Córdoba",
  text: "Lo compré para dejarle el trámite encaminado a mis hijos. Los modelos de solicitud y el checklist valen cada peso."
}, {
  name: "Daniel, 47",
  detail: "Quilmes, Bs. As.",
  text: "Trabajo todo el día y no tenía tiempo de investigar. En un fin de semana armé la línea familiar completa. Recomendadísimo."
}, {
  name: "Alicia, 55",
  detail: "San Juan",
  text: "Me habían cotizado una fortuna gestores. Con el libro hago yo misma casi todo. El Excel organizador es una maravilla."
}, {
  name: "Jorge, 63",
  detail: "Mar del Plata",
  text: "Explica la reforma de 2025 mejor que muchos videos. Me sacó todas las dudas antes de gastar en apostillas. Excelente."
}];
export function Testimonials() {
  return <section className="w-full bg-beige px-5 py-10" data-id="element-158" data-mp="7925mohkpj6g">
      <div className="mx-auto max-w-md" data-id="element-159" data-mp="c6lknqm3hzzg">
        <h2 className="text-center font-serif text-2xl font-bold text-deep-green" data-id="element-160" data-mp="c7mz852bl4lx">
          Argentinos que ya avanzan con su ciudadanía
        </h2>

        <div className="mt-6 space-y-4" data-id="element-161" data-mp="14vj0zo6qxmpk">
          {TESTIMONIALS.map(t => <figure key={t.name} className="relative rounded-2xl border border-sand bg-cream p-4" data-id="element-162" data-mp="14xlu4h373vyi">
              <QuoteIcon className="absolute right-3 top-3 h-6 w-6 text-sand" aria-hidden="true" data-id="element-163" data-mp="v4xw5j0hbly7" />
              <div className="flex items-center gap-1 text-gold" data-id="element-164" data-mp="1itz9nko65nac">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold" aria-hidden="true" data-id="element-165" data-mp="1xi0lr5tr9nwj" data-mpi={i} />)}
              </div>
              <blockquote className="mt-2 text-sm leading-relaxed text-ink/85" data-id="element-166" data-mp="1ohay4penf3tw">
                {t.text}
              </blockquote>
              <figcaption className="mt-2 text-xs font-semibold text-italian-green" data-id="element-167" data-mp="1jh6dqoamdoye">
                {t.name} · <span className="text-ink/60" data-id="element-168" data-mp="1ek6iz9j808ml">{t.detail}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}